var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar",class:{ active: _vm.active }},[_c('div',{staticClass:"topbar__fill",style:({ width: _vm.pct + '%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }